import React from 'react';
import { useLang } from '../i18n/translations';
import { Link2 } from 'lucide-react';
import { toast } from 'sonner';

const channels = (url, text) => [
  { id: 'facebook', label: 'Facebook', icon: 'fa-facebook-f', color: '#1877F2', href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}` },
  { id: 'whatsapp', label: 'WhatsApp', icon: 'fa-whatsapp', color: '#25D366', href: `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}` },
  { id: 'viber', label: 'Viber', icon: 'fa-viber', color: '#7360F2', href: `viber://forward?text=${encodeURIComponent(`${text} ${url}`)}` },
];

export const ShareButtons = ({ url, text }) => {
  const { t } = useLang();

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success(t('linkCopied'));
    } catch {
      const ta = document.createElement('textarea');
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      toast.success(t('linkCopied'));
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      <span className="text-xs font-semibold text-slate-500 uppercase tracking-wide mr-1">{t('share')}:</span>
      {channels(url, text).map((c) => (
        <a key={c.id} href={c.href} target="_blank" rel="noreferrer" title={c.label} aria-label={`${t('share')} – ${c.label}`}
          data-testid={`share-${c.id}`}
          className="h-9 w-9 rounded-full flex items-center justify-center text-white transition-transform duration-200 hover:scale-110"
          style={{ backgroundColor: c.color }}>
          <i className={`fa-brands ${c.icon} text-[15px]`} />
        </a>
      ))}
      <button onClick={copyLink} title={t('copyLink')} aria-label={t('copyLink')} data-testid="share-copy-link"
        className="h-9 w-9 rounded-full flex items-center justify-center bg-slate-600 text-white transition-transform duration-200 hover:scale-110">
        <Link2 className="h-4 w-4" />
      </button>
    </div>
  );
};
